
//系统目录 / 药品剂型 接口相关的函数
import request from "../../untils/request.js"

//分页
export const getSeeDoctorKeyword = (params) => {
    return request.get("outpatient/medicalKeyword/page",{params})
}

//新增
export const addSeeDoctorKeyword = (data) => {
    return request.post("/outpatient/medicalKeyword",data)
}

//修改
export const editSeeDoctorKeyword = (data) => {
    return request.put("/outpatient/medicalKeyword",data)
}

//列表
export const getSeeDoctorKeywordList = (params) => {
    return request.get("/outpatient/medicalKeyword/list",{params})
}

export default{
}